
import { Control, ControlHelper, DesignerViewControls, Guid, IDesignerViewContainer } from '@genexus/designer-common';
import { Component, Prop, h, Host } from '@stencil/core';

@Component({
    tag: 'gx-designer-view-container',
    styleUrl: 'designer-view-container.scss',
    shadow: false,
})
export class DesignerViewContainer implements IDesignerViewContainer {

    @Prop() controls: DesignerViewControls;
    @Prop() toolbarHidden: boolean;
    @Prop() pointerEvents: boolean;

    render() {
        return (
            <Host class={!this.pointerEvents && "no-pointer-events"}>
                {
                    this.controls?.root && ControlHelper.getControls(this.controls.root).map(c => this._renderActiveDesigners(c))
                }
            </Host>
        );
    }

    private _renderActiveDesigners(control: Control) {
        if (!this.controls.active || this.controls.active.indexOf(control) >= 0) {
            return (
                <gx-designer-view control={control} toolbar-hidden={this.toolbarHidden}>
                    {
                        ControlHelper.getControls(control).map(c => this._renderActiveDesigners(c))
                    }
                </gx-designer-view>
            );
        } else {
            return (
                <div>
                    {
                        ControlHelper.getControls(control).map(c => this._renderActiveDesigners(c))
                    }
                </div>
            );
        }
    }
}

